import { render } from "./BeListPage.vue?vue&type=template&id=8ad69a46&scoped=true"
import script from "./BeListPage.vue?vue&type=script&lang=js"
export * from "./BeListPage.vue?vue&type=script&lang=js"

import "./BeListPage.vue?vue&type=style&index=0&id=8ad69a46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ad69a46"]])

export default __exports__